var map = {
	"./2020.json": [
		1974,
		144
	],
	"./2021.json": [
		1975,
		145
	],
	"./2022.json": [
		1976,
		146
	],
	"./2023.json": [
		1977,
		147
	],
	"./2024.json": [
		1978,
		148
	],
	"./2025.json": [
		1979,
		149
	],
	"./2026.json": [
		1980,
		150
	],
	"./2027.json": [
		1981,
		151
	],
	"./2028.json": [
		1982,
		152
	],
	"./2029.json": [
		1983,
		153
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1528;
module.exports = webpackAsyncContext;